import React from 'react';
import styled from 'styled-components';

const ErrorMessageStyle = styled.div`
  color: red;
  font-size: 12px;
  width: 100%;
`;

export type ErrorMessageType = string | undefined;

interface ErrorMessageProps {
  message?: ErrorMessageType;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, children }) => {
  return <ErrorMessageStyle>{message || children}</ErrorMessageStyle>;
};
